module.exports = __webpack_public_path__ + "static/media/ehealth_ehr_lite_banner_desktop.e046515e.jpg";